import { render, staticRenderFns } from "./BasicSearch.vue?vue&type=template&id=3517b392&"
import script from "./BasicSearch.vue?vue&type=script&lang=js&"
export * from "./BasicSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports